export default "__VITE_ASSET__DNRI9eMk__";